import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

export function showLoadingDialog(context) {
  if (context.state.loading_dialog === undefined) { context.state.loading_dialog = false; }
  if (context.state.loading_dialog) {
    return (
      <div className='view_center' style={{position : 'fixed', width : '100%', height : '100%', backgroundColor : 'rgba(0,0,0,0.5)'}}>
        <ClipLoader color='#88888' loading={true} size={50} />
      </div>
    );
  } else { return null; }
}

export function showLoadingPage(context) {
  if (context.state.loading_page === undefined) { context.state.loading_page = false; }
  if (context.state.loading_page) {
    return (
      <div className='view_center' style={{position : 'fixed', width : '100%', height : '100%', backgroundColor : 'white'}}>
        <ClipLoader color='#88888' loading={true} size={50} />
      </div>
    );
  } else { return null; }
}

export function showProgressDialog(context) {
  if (context.state.progress_dialog === undefined) { context.state.progress_dialog = false; }
  if (context.state.m_progress === undefined) { context.state.m_progress = 0; }
  if (context.state.progress_dialog) {
    return (
      <div className='view_center' style={{position : 'fixed', width : '100%', height : '100%', backgroundColor : 'rgba(0,0,0,0.5)'}}>
        <ClipLoader color='#88888' loading={true} size={120} />
        <div style={{position : 'absolute'}} className='txt_20 fnt_wht_a'>{context.state.m_progress} %</div>
      </div>
    );
  } else { return null; }
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
